/** The raw technical error, folded away by default: the friendly sentence next to it is what most people need. */
export function ErrorDetail({ text }: { text: string }) {
  return (
    <details className="text-xs">
      <summary className="cursor-pointer select-none font-mono text-muted hover:text-ink">technical details</summary>
      <code className="mt-1.5 block whitespace-pre-wrap break-words">{text}</code>
    </details>
  );
}
